const ServiceFeatures = () => {
  const features = [
    {
      icon: 'ri-building-4-line',
      title: 'Concrete Block Wall Filling',
      description: 'Complete filling services for all types of concrete block walls, ensuring structural integrity and longevity.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Structural Reinforcement',
      description: 'Professional reinforcement techniques that meet or exceed building codes and engineering specifications.'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Foundation Block Work',
      description: 'Specialized foundation block filling for residential and commercial buildings, providing solid support.'
    },
    {
      icon: 'ri-community-line',
      title: 'Commercial & Residential',
      description: 'Serving both commercial contractors and residential homeowners with the same level of expertise and care.'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Quality Assurance',
      description: 'Rigorous quality control processes ensure every block is properly filled and meets structural requirements.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Expert Equipment',
      description: 'State-of-the-art pumping equipment designed specifically for precise block filling applications.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Comprehensive Block Filling Solutions
          </h2>
          <p className="text-lg text-slate-600">
            From residential foundations to commercial structures, we deliver professional block filling services with precision and reliability.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-lg p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFeatures;